var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrcStatusV2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.912 1.0166H7.63698C7.15143 1.0166 6.75781 1.41022 6.75781 1.89577V3.6541C6.75781 4.13965 7.15143 4.53326 7.63698 4.53326H12.912C13.3975 4.53326 13.7911 4.13965 13.7911 3.6541V1.89577C13.7911 1.41022 13.3975 1.0166 12.912 1.0166Z",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7961 2.77502H15.5544C16.0207 2.77502 16.468 2.96028 16.7977 3.29003C17.1275 3.61978 17.3127 4.06702 17.3127 4.53335V16.8417C17.3127 17.308 17.1275 17.7552 16.7977 18.085C16.468 18.4147 16.0207 18.6 15.5544 18.6H5.00442C4.53809 18.6 4.09085 18.4147 3.7611 18.085C3.43135 17.7552 3.24609 17.308 3.24609 16.8417V4.53335C3.24609 4.06702 3.43135 3.61978 3.7611 3.29003C4.09085 2.96028 4.53809 2.77502 5.00442 2.77502H6.76275",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.64062 11.5667L9.39895 13.325L12.9156 9.80835",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrcStatusV2);
export default __webpack_public_path__ + "static/media/grcStatusV2.061b982b57beb761f3805589c868c7b8.svg";
export { ForwardRef as ReactComponent };